"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/styles");

var _core = require("@material-ui/core");

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    marginBottom: {
      marginBottom: 20
    },
    formLabel: {
      fontSize: 12,
      marginTop: 3
    },
    colorPicker: {
      width: "100%",
      marginTop: ".2rem",
      marginBottom: "1rem"
    }
  };
});

var AttributesAccordion = function AttributesAccordion(_ref) {
  var properties = _ref.properties,
      handlePropertyChange = _ref.handlePropertyChange,
      typeForm = _ref.typeForm;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement(_core.TextField, {
    label: "Etiqueta",
    value: properties.label,
    onChange: function onChange(e) {
      handlePropertyChange(properties, "label", e.target.value);
    },
    className: classes.marginBottom,
    disabled: typeForm === "multiple"
  }));
};

var _default = AttributesAccordion;
exports.default = _default;